import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-charts/themeAugmentation';

import { capitalCategoricalPalette } from '../../capitalCategoricalPalette';

export const MuiChartsDataProvider: ThemeOptions['components']['MuiChartsDataProvider'] = {
  defaultProps: {
    colors: capitalCategoricalPalette
  }
};
